import { createContext } from 'react';
import type { SsoTypes } from './utils';

interface IAuthStepStartContext {
	email: string;
	forceSSO: SsoTypes | null;
	supportedMethods: (SsoTypes | 'email')[];
	resetSSO: () => void;
	setEmail: (email: string) => void;
	startEmailAuth: () => void;
	startSamlAuth: (domain: string) => void;
	error: string | null;
	setError: (error: string | null) => void;
}

export const AuthStepStartContext = createContext<
	IAuthStepStartContext | undefined
>(undefined);
